module.exports = __webpack_public_path__ + "img/disconnected.adb6ffb9.svg";